import { Dispatch } from 'redux';
import * as api from '../utils/api';
import { NavigateFunction } from 'react-router-dom';

const actions = {
  GET: 'lms-ui/platformData/GET',
  UPDATE_MAINTENANCE: 'lms-ui/platformData/UPDATE_MAINTENANCE',
};

interface IPlatformDataState {
  messages: IMessage[];
  maintenance?: IMaintenance;
}

interface IPlatformDataAction {
  type: typeof actions.GET;
  payload: IPlatformDataState[];
}

type PlatformDataActionTypes = IPlatformDataAction;

const initialState: IPlatformDataState = {
  messages: [],
  maintenance: undefined,
};

export const inMaintenanceMode = (maintenance?: IMaintenance) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const showLogin = urlParams.get('showLogin') === '1';

  if (!maintenance?.start || maintenance?.allowed || showLogin) return false;

  const start = new Date(maintenance.start);
  return start.getTime() <= Date.now();
};

export const getPlatformData = (navigate?: NavigateFunction) => async (dispatch: Dispatch) => {
  try {
    const response = await api.getPlatformData();
    const data = response.data as IPlatformDataState;
    dispatch({ type: actions.GET, payload: data });

    if (inMaintenanceMode(data.maintenance)) {
      if (navigate) {
        navigate(`/maintenance`);
        return true;
      }
    }
  } catch (e) {
    console.error(e);
  }
};

export const updateMaintenance = (maintenance?: IMaintenance) => async (dispatch: Dispatch) => {
  dispatch({ type: actions.UPDATE_MAINTENANCE, payload: maintenance });
};

export default function reducer(
  state = initialState,
  action: PlatformDataActionTypes,
): IPlatformDataState {
  switch (action.type) {
    case actions.GET: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actions.UPDATE_MAINTENANCE: {
      return {
        ...state,
        maintenance: action.payload as IMaintenance,
      };
    }
    default:
      return state;
  }
}
